export type Pillar = "Autoridade" | "Prova" | "Conversão";

export type Post = {
  id: number;
  pillar: Pillar;
  title: string;
  art: string;
  caption: string;
  reels?: string;
};

const CTA = "\n\nOrçamento gratuito e sem compromisso: chama no WhatsApp (link na bio).";

const TAGS =
  "\n\n#pinturapredial #ropeaccess #pinturadeemalturas #fachada #condominio #sindico #sindicoprofissional #saopaulo #zonasul #zonaoeste #abc #manutencaopredial #nr35 #pintorprofissional #kronopaint";

export const POSTS: Post[] = [
  {
    id: 1,
    pillar: "Autoridade",
    title: "O que é Rope Access?",
    art: "/assets/post-01.png",
    caption:
      "Você já viu alguém descendo um prédio por cordas e pensou: “isso é seguro?”\n\nÉ o rope access — técnica industrial usada no mundo inteiro em plataformas de petróleo, torres eólicas e arranha-céus. Cada técnico desce preso a DUAS cordas independentes (trabalho + segurança), com equipamentos certificados e inspeção diária.\n\nResultado: acesso total à fachada, sem andaime ocupando seu condomínio por meses.\n\nSalva esse post pra mostrar na próxima assembleia." + CTA + TAGS,
  },
  {
    id: 2,
    pillar: "Autoridade",
    title: "NR-35: exija.",
    art: "/assets/post-02.png",
    caption:
      "Antes de contratar qualquer empresa para trabalho em altura, faça 1 pergunta: “a equipe tem NR-35 em dia?”\n\nA NR-35 é a norma que regulamenta trabalho em altura no Brasil. Ela exige treinamento, exames, plano de resgate e supervisão qualificada.\n\nEmpresa sem NR-35 = risco jurídico pro condomínio e risco de vida pro trabalhador.\n\nNa KRONO, toda equipe é certificada e toda obra sai com ART assinada. Síndico protegido, morador tranquilo." + CTA + TAGS,
  },
  {
    id: 3,
    pillar: "Autoridade",
    title: "Andaime x Cadeirinha",
    art: "/assets/post-03.png",
    caption:
      "ANDAIME: semanas de montagem, estrutura na calçada, ferro na janela do morador, custo de locação correndo todo mês.\n\nROPE ACCESS (cadeirinha): montagem no mesmo dia, zero estrutura no térreo, equipe móvel que pinta face por face.\n\nPra fachada de prédio, a conta fecha quase sempre pro rope access: menos prazo, menos transtorno, menos custo.\n\nManda esse post pro grupo do condomínio." + CTA + TAGS,
  },
  {
    id: 4,
    pillar: "Autoridade",
    title: "5 sinais de fachada em risco",
    art: "/assets/post-04.png",
    caption:
      "Sua fachada está pedindo socorro se você vê:\n\n1. Manchas escuras e verdes (mofo/infiltração)\n2. Rachaduras e fissuras abrindo\n3. Tinta descascando ou “estufada”\n4. Eflorescência (pó branco na parede)\n5. Pastilhas ou reboco soltos\n\nCada sinal desses piora com a chuva — e vira infiltração dentro do apartamento. Manutenção preventiva custa uma fração do reparo emergencial." + CTA + TAGS,
  },
  {
    id: 5,
    pillar: "Prova",
    title: "Reels: equipe descendo",
    art: "/assets/post-05.png",
    caption:
      "O momento que todo morador vai pra janela ver: a equipe descendo.\n\nRope access não é maluquice — é método. Duas cordas, EPI certificado, inspeção antes de cada descida e supervisão em solo.\n\nO resultado você vê na fachada. O processo você vê aqui." + CTA + TAGS,
    reels:
      "ROTEIRO (15-20s) — Gancho: comece com a câmera no térreo apontando pra cima, texto na tela: “Eles vão pintar esse prédio inteiro SEM ANDAIME”. Cortes: (1) close no nó/cadeirinha, (2) técnico passando pela borda, (3) plano aberto da descida, (4) rosto do morador olhando da janela. Texto final: “Rope access. NR-35. Zero andaime.” Áudio: som ambiente + música tensa/cinematográfica em alta. Grave na vertical, 4K se possível, estabilize o celular contra uma superfície.",
  },
  {
    id: 6,
    pillar: "Prova",
    title: "Reels: checklist de EPI",
    art: "/assets/post-06.png",
    caption:
      "Antes de qualquer descida, TUDO é inspecionado: capacete, cadeirinha, trava-quedas, mosquetões, cordas.\n\nEPI com CA (Certificado de Aprovação) e checklist assinado. Não é frescura — é o que separa profissional de aventureiro.\n\nSíndico: pode cobrar isso de qualquer empresa que pisar no seu condomínio." + CTA + TAGS,
    reels:
      "ROTEIRO (20s) — Formato “checklist ASMR”: mostre cada EPI em close na mesa (capacete, cadeirinha, trava-quedas, mosquetão, corda) com um “check” estalado na tela a cada item. Ordem dos cortes: 1 item por segundo. Texto na tela: “O que inspecionamos ANTES de descer”. Encerre vestindo o equipamento + olhando pra câmera: “Segurança não é detalhe.” Áudio: ASMR dos cliques dos mosquetões ou beat seco.",
  },
  {
    id: 7,
    pillar: "Prova",
    title: "Reels: preparo da tinta",
    art: "/assets/post-07.png",
    caption:
      "O acabamento premium começa ANTES da parede: tinta certa, diluição certa, mistura homogênea.\n\nA gente usa linhas premium de fachada com garantia do fabricante — porque tinta barata sai caro: desbota em 2 anos e o prédio precisa pintar de novo.\n\nObra boa é a que você não precisa refazer." + CTA + TAGS,
    reels:
      "ROTEIRO (10-15s) — Close hipnótico da tinta sendo misturada (misturador girando, espiral da tinta). Corte seco pra: lata com rótulo, depois rolo carregado escorrendo. Texto na tela: “O segredo do acabamento está aqui” → “Tinta premium + preparo certo”. Áudio: som ambiente do misturador ou lo-fi. Esse formato performa muito bem (satisfying).",
  },
  {
    id: 8,
    pillar: "Prova",
    title: "Reels: antes/depois time-lapse",
    art: "/assets/post-08.png",
    caption:
      "De um lado: anos de poluição, chuva e sol de SP.\nDo outro: fachada nova, impermeabilizada e pintada.\n\nTime-lapse de obra é a prova mais honesta que existe — sem filtro, sem edição milagrosa.\n\nSeu prédio pode ser o próximo." + CTA + TAGS,
    reels:
      "ROTEIRO (15-30s) — Time-lapse fixo: prenda o celular num tripé/janela com a MESMA moldagem do início ao fim da obra (1 foto a cada 30-60min ou vídeo acelerado 8-16x). Abertura: 1s do “ANTES” em texto grande. Fechamento: segure 2s no “DEPOIS” + texto “Seu prédio merece nascer de novo — orçamento gratuito no link da bio”. Áudio: música épica crescente. IMPORTANTE: grave o antes mesmo com a fachada feia — é o que vende.",
  },
  {
    id: 9,
    pillar: "Conversão",
    title: "Seu prédio está assim?",
    art: "/assets/post-09.png",
    caption:
      "Fachada manchada, rachada, com tinta soltando?\n\nIsso não é só estética: é a impermeabilização indo embora e a infiltração chegando.\n\nA boa notícia: com rope access, a reforma é mais rápida e mais barata do que você imagina — sem andaime, sem obra interminável.\n\nManda uma foto da sua fachada no nosso WhatsApp e receba uma pré-avaliação GRATUITA." + CTA + TAGS,
  },
  {
    id: 10,
    pillar: "Conversão",
    title: "Depoimento (template)",
    art: "/assets/post-10.png",
    caption:
      "[ TEMPLATE — substitua pelo primeiro depoimento real ]\n\n“Trabalho impecável, sem andaime e sem transtorno pro condomínio.”\n— Síndico, Zona Sul SP\n\nQuando a primeira obra terminar, peça 1 frase do síndico por WhatsApp, troque aqui e reposte. Depoimento real converte mais que qualquer anúncio." + CTA + TAGS,
  },
  {
    id: 11,
    pillar: "Conversão",
    title: "Orçamento gratuito",
    art: "/assets/post-11.png",
    caption:
      "ORÇAMENTO GRATUITO em até 24h.\n\nFunciona assim: você chama no WhatsApp, manda endereço + fotos da fachada, e recebe uma pré-avaliação sem compromisso.\n\nSem taxa de visita. Sem enrolação. Sem andaime.\n\nSalva esse post e manda pro síndico do seu prédio." + CTA + TAGS,
  },
  {
    id: 12,
    pillar: "Conversão",
    title: "Atendemos toda SP",
    art: "/assets/post-12.png",
    caption:
      "Zona Sul, Zona Oeste, Centro, Zona Norte, Zona Leste, ABC, Osasco, Barueri, Guarulhos...\n\nSe o seu prédio é em São Paulo e região, a KRONO atende.\n\nMarca aqui um síndico ou vizinho que precisa ver isso." + CTA + TAGS,
  },
];

export const PILLARS: { name: Pillar; desc: string }[] = [
  { name: "Autoridade", desc: "Educa o síndico e posiciona a KRONO como referência técnica." },
  { name: "Prova", desc: "Bastidores reais: roteiros pra gravar no celular na primeira obra." },
  { name: "Conversão", desc: "Chama pro WhatsApp com oferta clara e prova visual." },
];
